import React from 'react'
import ReactDOM from 'react-dom'
import logger from 'redux-logger'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import ReduxToastr from 'react-redux-toastr'
import _ from "lodash"

import './global-styles/index.scss'

// Redux
import Reducers from './reducers'

import App from './containers/app'
import {unregister} from './registerServiceWorker'

import { checkIfLoggedIn } from './auth'

import {setSettings} from './actions/settings'

import {translate} from './translate'

const consentSettings = {
  bootstrapDivId: window.consentSettings.bootstrapDivId || 'app',
  organizationName: window.consentSettings.organizationName || 'Merkantilbygg',
  language: window.consentSettings.language || 'nb',
  customHtmlMarkup: {
    headerTag: _.has(window, "consentSettings.customHtmlMarkup.headerTag") ? window.consentSettings.customHtmlMarkup.headerTag : 'h1', // Header html tag
    subheaderTag: _.has(window, "consentSettings.customHtmlMarkup.subheaderTag") ? window.consentSettings.customHtmlMarkup.subheaderTag : 'h2', // Subheader html tag
  },
  customCssClasses: {
    submitButtonClass: _.has(window, "consentSettings.customCssClasses.submitButtonClass") ? window.consentSettings.customCssClasses.submitButtonClass : null, // Submit button css class
    inputClass: _.has(window, "consentSettings.customCssClasses.inputClass") ? window.consentSettings.customCssClasses.inputClass : null, // Input text and email css class
    inputWrapperClass: _.has(window, "consentSettings.customCssClasses.inputWrapperClass") ? window.consentSettings.customCssClasses.inputWrapperClass : null, // Input text and email wrapper css class
    checkboxClass: _.has(window, "consentSettings.customCssClasses.checkboxClass") ? window.consentSettings.customCssClasses.checkboxClass : null, // Checkbox css class
  }
}

if (window.consentSettings) {
  let store = createStore(Reducers, applyMiddleware(logger))
  checkIfLoggedIn({store: store})

  store.dispatch(setSettings(consentSettings))

  ReactDOM.render(
    <Provider store={store}>
      <div>
        <div dangerouslySetInnerHTML={{__html: '<'+consentSettings.customHtmlMarkup.headerTag+'>' + translate('index.heading', consentSettings.language) + '</'+consentSettings.customHtmlMarkup.headerTag+'>'}} />
        <App />
        <ReduxToastr
          timeOut={4000}
          newestOnTop={false}
          preventDuplicates
          position="bottom-right"
          transitionIn="fadeIn"
          transitionOut="fadeOut"
          progressBar/>
      </div>
    </Provider>,
    document.getElementById(consentSettings.bootstrapDivId)
  )

unregister()
}



// WEBPACK FOOTER //
// ./src/index.js